"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarFallback = exports.AvatarImage = exports.Avatar = void 0;
const react_1 = __importDefault(require("react"));
const class_variance_authority_1 = require("class-variance-authority");
// Define styles using cva with the `` prefix
const avatarStyles = (0, class_variance_authority_1.cva)("relative w-16 h-16 rounded-full overflow-hidden bg-grey200", {
    variants: {
        shape: {
            circle: "rounded-full",
            square: "rounded-none",
        },
        size: {
            small: "w-12 h-12",
            medium: "w-16 h-16",
            large: "w-24 h-24",
        },
    },
    defaultVariants: {
        shape: "circle",
        size: "medium",
    },
});
const Avatar = ({ children, shape, size, }) => {
    return react_1.default.createElement("div", { className: avatarStyles({ shape, size }) }, children);
};
exports.Avatar = Avatar;
const avatarImageStyles = (0, class_variance_authority_1.cva)("w-full h-full object-cover", {
    variants: {
        shape: {
            circle: "rounded-full",
            square: "rounded-none",
        },
    },
    defaultVariants: {
        shape: "circle",
    },
});
const AvatarImage = ({ src, alt, shape }) => {
    return react_1.default.createElement("img", { src: src, alt: alt, className: avatarImageStyles({ shape }) });
};
exports.AvatarImage = AvatarImage;
const avatarFallbackStyles = (0, class_variance_authority_1.cva)("flex items-center justify-center w-full h-full text-white bg-blue-500", {
    variants: {
        shape: {
            circle: "rounded-full",
            square: "rounded-none",
        },
    },
    defaultVariants: {
        shape: "circle",
    },
});
const AvatarFallback = ({ children, shape }) => {
    return react_1.default.createElement("div", { className: avatarFallbackStyles({ shape }) }, children);
};
exports.AvatarFallback = AvatarFallback;
